"use strict";

exports.__esModule = true;
exports.linkStyles = exports.getUIColors = exports.getSpacing = exports.buttonStyles = void 0;

var _styledComponents = require("styled-components");

var _styles = require("@qc-modules/styles");

var _excluded = ["color", "hover", "ui", "version"],
    _excluded2 = ["color", "hover", "ui"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var spacingStyles = {
  large: {
    px: 5,
    py: 2
  },
  medium: {
    px: 4,
    py: 2
  },
  small: {
    px: 2,
    py: 1
  }
};
var uiColors = {
  dark: {
    link: {
      color: "background",
      hover: "background"
    },
    primary: {
      color: "background-selected",
      hover: "button-hover"
    },
    secondary: {
      color: "shadow",
      hover: "shadow"
    },
    "secondary-v2": {
      color: "background-selected",
      hover: "button-hover"
    },
    tertiary: {
      color: "background",
      hover: "background"
    }
  },
  light: {
    link: {
      color: "background-selected",
      hover: "button-hover"
    },
    pill: {
      color: "secondary-blue",
      hover: "secondary-blue"
    },
    primary: {
      color: "background-selected",
      hover: "button-hover"
    },
    secondary: {
      color: "background-selected",
      hover: "button-hover"
    },
    "secondary-v2": {
      color: "background-selected",
      hover: "button-hover"
    },
    tertiary: {
      color: "background-selected",
      hover: "button-hover"
    }
  }
};

var getSpacing = function getSpacing(version, size) {
  return version !== "link" ? Object.assign({}, spacingStyles[size]) : {};
};

exports.getSpacing = getSpacing;

var getUIColors = function getUIColors(ui, version) {
  return uiColors[ui][version];
};

exports.getUIColors = getUIColors;
var common = (0, _styledComponents.css)(["border-radius:50px;display:inline-block;"]);

var buttonStyles = function buttonStyles(_ref) {
  var color = _ref.color,
      hover = _ref.hover,
      ui = _ref.ui,
      version = _ref.version,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  if (version === "secondary") {
    return (0, _styledComponents.css)(["", ";fill:", ";color:", ";border:1px solid transparent;background-color:", ";&:hover{background-color:", ";}"], common, (0, _styles.colors)("text-light", props), (0, _styles.colors)("text-light", props), ui === "dark" ? (0, _styles.themeTransparentize)(0.8, color, props) : (0, _styles.colors)(color, props), ui === "dark" ? (0, _styles.themeTransparentize)(0.65, hover, props) : (0, _styles.themeDarken)(0.15, hover, props));
  }

  if (version === "tertiary") {
    return (0, _styledComponents.css)(["", ";fill:", ";color:", ";background-color:", ";border:1px solid ", ";&:hover{", ";}"], common, (0, _styles.colors)(color, props), (0, _styles.colors)(color, props), ui === "dark" ? (0, _styles.themeTransparentize)(1, "background", props) : "transparent", (0, _styles.colors)(color, props), ui === "dark" ? (0, _styledComponents.css)(["background-color:", ";"], (0, _styles.themeTransparentize)(0.8, "background", props)) : (0, _styledComponents.css)(["background-color:transparent;border:1px solid ", ";fill:", ";color:", ";"], (0, _styles.themeDarken)(0.15, hover, props), (0, _styles.themeDarken)(0.15, hover, props), (0, _styles.themeDarken)(0.15, hover, props)));
  }

  if (version === "pill") {
    return (0, _styledComponents.css)(["", " ", ";fill:", ";color:", ";fill:", ";background-color:", ";border:1px solid ", ";&:hover{", ";background-color:", ";fill:", ";color:", ";}"], common, (0, _styles.transitionEase)("0.2s", ["background-color", "color", "border-color", "opacity"]), (0, _styles.colors)(color, props), (0, _styles.colors)(color, props), (0, _styles.colors)(color, props), (0, _styles.colors)("background", props), (0, _styles.colors)(color, props), (0, _styles.transitionEase)("0.25s", ["background-color", "color", "border-color", "opacity"]), (0, _styles.colors)(hover, props), (0, _styles.colors)("text-light", props), (0, _styles.colors)("text-light", props));
  }

  return (0, _styledComponents.css)(["", ";position:relative;fill:", ";color:", ";border:1px solid ", ";background-color:", ";&:hover{fill:", ";color:", ";}"], common, (0, _styles.colors)(color, props), (0, _styles.colors)(color, props), (0, _styles.colors)("background", props), (0, _styles.colors)("background", props), (0, _styles.themeDarken)(0.15, hover, props), (0, _styles.themeDarken)(0.15, hover, props));
};

exports.buttonStyles = buttonStyles;

var linkStyles = function linkStyles(_ref2) {
  var color = _ref2.color,
      hover = _ref2.hover,
      ui = _ref2.ui,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  return (0, _styledComponents.css)(["fill:", ";color:", ";&:hover{", ";}"], (0, _styles.colors)(color, props), (0, _styles.colors)(color, props), ui === "dark" ? (0, _styledComponents.css)(["opacity:0.5;"]) : (0, _styledComponents.css)(["fill:", ";color:", ";"], (0, _styles.themeDarken)(0.15, hover, props), (0, _styles.themeDarken)(0.15, hover, props)));
};

exports.linkStyles = linkStyles;